// Site configuration constants
export const BASE_URL = 'https://localcraftisrael.com';
export const SITE_NAME = 'LocalCraft Israel';
export const DEFAULT_OG_IMAGE = `${BASE_URL}/seo/default-preview.jpg`;

// Social media
export const TWITTER_HANDLE = '@localcraftil';
export const FACEBOOK_URL = 'https://facebook.com/localcraftisrael';
export const INSTAGRAM_URL = 'https://instagram.com/localcraftisrael';

// SEO defaults
export const DEFAULT_DESCRIPTION = 'Discover authentic handmade products from Israeli artisans. Support local crafts and bring home unique treasures.';
export const DEFAULT_KEYWORDS = 'handmade, Israel, crafts, artisan, authentic, local, marketplace';

// Business info
export const BUSINESS_NAME = 'LocalCraft Israel';
export const BUSINESS_COUNTRY = 'Israel';
export const BUSINESS_CURRENCY = 'ILS';
